'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSortNumericAsc = function FaSortNumericAsc(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33 29.3q0-1.4-0.9-2.6t-2.3-1.2q-1.2 0-1.9 0.9t-0.7 2.1 0.8 2.1 2.4 0.8q1.1 0 1.9-0.6t0.7-1.5z m-13.6 2.8q0 0.3-0.2 0.6l-7.1 7.1q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2l-7.2-7.1q-0.3-0.4-0.1-0.8 0.1-0.5 0.6-0.5h4.3v-30.7q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v30.7h4.3q0.3 0 0.5 0.2t0.2 0.5z m16.8-1.5q0 1.4-0.3 2.7t-0.9 2.6-1.6 2.1-2.2 1.5-2.8 0.5q-1.4 0-2.4-0.4-0.5-0.1-0.9-0.3l0.8-2.5q0.4 0.1 0.7 0.2 0.8 0.3 1.7 0.3 1.9 0 3-1.3t1.5-3.2h-0.1q-0.4 0.5-1.3 0.8t-1.9 0.3q-2.4 0-3.9-1.6t-1.5-3.8q0-2.4 1.6-4t4.1-1.6q2.7 0 4.5 2.1t1.9 5.6z m-0.7-16v2.5h-10.5v-2.5h3.8v-9.6q0-0.2 0-0.5t0-0.3v-0.4h-0.1l-0.1 0.3q-0.2 0.3-0.6 0.7l-1.4 1.2-1.8-1.9 4.3-4.1h2.7v14.6h3.7z' })
        )
    );
};

exports.default = FaSortNumericAsc;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/sort-numeric-asc.js
// module id = 1023
// module chunks = 168707334958949